// extracted by mini-css-extract-plugin
module.exports = {"container":"IncidentItem_container__1LPEn","link":"IncidentItem_link__qXhFR","gray":"IncidentItem_gray__IltKr","item":"IncidentItem_item__ccvHu"};